import { Component, OnInit, EventEmitter, TemplateRef, ElementRef, ChangeDetectionStrategy, Output, Input, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NbToastRef, NbDialogService } from '@nebular/theme';
import { NbToastrService } from '@nebular/theme';
import { Base64 } from 'js-base64';
import { Grid } from 'ng2-smart-table/lib/grid';
import { Row } from 'ng2-smart-table/lib/data-set/row';
import { deepExtend } from 'ng2-smart-table/lib/helpers';
import { JurPerson } from '../../@core/data/jur-person';
import { bank } from '../../@core/data/bank';
import { RestService } from '../../@core/utils/rest.service';
import { ShowcaseDialogComponent } from '../../pages/modal-overlays/dialog/showcase-dialog/showcase-dialog.component';
import { Person } from '../../@core/data/person';
import { SmartTableData } from '../../@core/data/smart-table';
import { LocalDataSource } from 'ng2-smart-table';
import { sector } from '../../@core/data/sector';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl } from '@angular/forms';
import { formatDate } from '@angular/common';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DataSource } from 'ng2-smart-table/lib/data-source/data-source';

//import { CustomEditorComponent1 } from './custom-editor.component.1';
import { CustomEditorComponent2 } from './custom-editor.component.2';
import { CustomEditorComponent3 } from './custom-editor.component.3';
import { CustomEditorComponent4 } from './custom-editor.component.4';
import { CustomEditorComponent5 } from './custom-editor.component.5';
import { CustomEditorComponent6 } from './custom-editor.component.6';
import { CustomEditorComponent7 } from './custom-editor.component.7';
import { NgxSoapService, Client, ISoapMethodResponse } from 'ngx-soap';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss'
declare var pdfMake: any;
declare var buildPdf: any;
declare var $: any;
// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { Overlay, ConnectedPositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { CustomEditorComponent8 } from './custom-editor.component.8';
import { NcalayerService } from '../../@core/utils/ncalayer/ncalayer.service';
import { Result } from '../../@core/data/result';
import { CustomEditorComponent15 } from './custom-editor.component.15';
import { MatStepper } from '@angular/material';
import { ifStmt } from '@angular/compiler/src/output/output_ast';
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
});
export class ReciverList {
  account: string;
  bank: string;
  bik: string;
  bin: string;
  code: string;
  kBe: string;
  name: string;
}
class pers {
  BEGINDATE: string
  BIRTHDATE: string
  EDIT: string
  ENDDATE: string
  FM: string;
  FT: string;
  G_PERSON: string;
  IDN: string;
  NM: string;
  PERIOD: string;
  SUM: string
}
export interface DETAIL {
  IIN: string;
  LASTNAME: string;
  FIRSTNAME: string;
  MIDDLENAME: string;
  PHONE: string;
  SUM: string;
  PERIOD: string;

}
class dtClass implements DETAIL {
  constructor(
    public IIN: string,
    public LASTNAME: string,
    public FIRSTNAME: string,
    public MIDDLENAME: string,
    public PHONE: string,
    public SUM: string,

    public PERIOD: string) { }
}

export interface PaymentsType {
  TXN_ID: string;
  BIN: string;
  TOTALSUM: string;
  CONTRACTTYPE: string;
  CUSTOMER_KEY: string;
  TXN_DATE: string;
  SIGNATURE: string;
  LANG: string;
  ASSIGN: string;
  DETAIL: DETAIL[];
}

class PaymentsTypeClass implements PaymentsType {
  public TXN_ID: string;
  public BIN: string;
  public TOTALSUM: string;
  public CONTRACTTYPE: string;
  public CUSTOMER_KEY: string;
  public TXN_DATE: string;
  public SIGNATURE: string;
  public LANG: string;
  public ASSIGN: string;
  public DETAIL: any;
  DATEPAY: string;
  DATEVAL: string;
  MFO: string;
  BANK: string;
  IBAN: string;
  NUM: string;
  public token: string;
}

@Component({
  selector: 'ngx-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  outputs: ['changeTab'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})


export class PaymentComponent implements OnInit, AfterViewInit {

  @ViewChild("#picker3") picker3: ElementRef;
  @ViewChild('table') table: ElementRef;
  @Output() userRowSelect = new EventEmitter<any>();
  @Output() rowSelect = new EventEmitter<any>();

  @ViewChild('stepper') private stepper: MatStepper;

  public smatTable: SmartTableData;
  numbers: string;
  numberBudget: string;
  residentType: string = '';
  grid: Grid;
  linearMode: boolean = true;
  firstForm: FormGroup;
  secondForm: FormGroup;
  thirdForm: FormGroup;
  numberPayment: string='';
  datePayment: string;
  datePayment1: string;
  assign: string;
  title: any;
  KBE: string;
  BIC: string;
  BIN: string;
  IBAN: string;
  data4: any;
  totalsum: any;
  settings: any;
  personsN: any[];
  public index: number = 0;
  public jurPerson: JurPerson;
  public banks: bank[];
  public sector: sector[] = [];
  public sector2: sector[] = [];
  public persons: Person[];
  public item: { firstName: string, lastName: string } =
    { firstName: this.numberPayment, lastName: '' };
  pdf: any;
  dataA: any;
  data1: any;
  isComplate: boolean;
  isComplate1: boolean;
  isComplate2: boolean;

  today = new FormControl(new Date());
  today1 = new FormControl(new Date());
  today2 = new Date();
  newPersons: any;
  reciver: any[];
  data3: any;
  indexEconome: number = 0;
  payment: any[];
  blnkStatus: boolean = true;
  selectedPayment: boolean;
  selectedValue: boolean;
  objectLang: any;
  Name: string;
  address: any;
  nameCompany: any;
  ind: any;
  chief: any;
  resiverName: any;
  idn: any;
  bicBank: any;
  nameBank: any;
  static this: any;
  reciverData: any;
  token: any;

  //buildPdf: any = new buildPdf();

  source: LocalDataSource;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  isOptional = false;
  noDatValue: any;

  constructor(
    private fb: FormBuilder,
    private toastrService: NbToastrService,
    public rest: RestService,
    private dialogService: NbDialogService,
    private service: SmartTableData,
    private hostElement: ElementRef,
    private sanitizer: DomSanitizer,
    private _formBuilder: FormBuilder,
    private overlay: Overlay,
    private router: Router,
    public ncalayer: NcalayerService,
    public translate: TranslateService,
    private changeDetectorRefs: ChangeDetectorRef
  ) {

  }

  buildPdf(value: any) {
    var pdfContent = value;
    var docDefinition = {
      content: [{
        text: 'My name is: ' + pdfContent.firstName + ' ' + pdfContent.lastName + '.'
      }]
    }
    console.log(pdfContent);
    return docDefinition;
  }
  showToast1(position: any, status: any, text: string) {
    this.toastrService.show(
      ' ',
      text,
      { position, status });
  }

  toggleLinearMode() {
    this.linearMode = !this.linearMode;
  }
  checkInputNumber() {
    if (/^[0-9]+$/.test(this.numberPayment)) {

      for (let i = 0; i < this.personsN.length; i++) {
        if (this.personsN[i].SUM == undefined) {
          // Swal.fire({
          //   text: "Сумма должна превышать нуля",
          //   type: 'error',
          //   confirmButtonText: 'OK',
          //   confirmButtonColor: "#008e54"
          // })
          this.isComplate = true;
        }
        else {
          this.isComplate = false;
        }
      }
      return 'success'

    }
    else {
      this.isComplate = true;
      return 'danger'

    }
  }
  checkInputSelect() {
    console.log('checkInputSelect');
    if (!this.residentType && !this.numbers && !this.numberBudget && !this.assign && this.selectedPayment && this.selectedValue) {
      this.isComplate1 = true;
      return 'danger'
    }
    else {
      this.isComplate1 = false;
      return 'success'
    };
  }

  openPdf() {
    this.pdf = pdfMake;
    //this.buildPdf = buildPdf;
    this.pdf.createPdf(this.buildPdf(this.item)).open();
  }



  translateLang(lang = "ru", loadData = false) {
    let actionValue = "";
    let noDatValue = "";

    noDatValue = sessionStorage.getItem('lang') == "0" ? "Нет данных" : "Мәлімет жоқ";

    let x = setInterval(() => {
      let elem = document.getElementsByClassName('ng2-smart-title')[0];
      noDatValue = sessionStorage.getItem('lang') == "0" ? "Нет данных" : "Мәлімет жоқ";
      actionValue = sessionStorage.getItem('lang') == "0" ? "Действия" : "Әрекет";
      if (typeof elem !== "undefined" && sessionStorage.getItem('lang') !== null) {
        elem.innerHTML = actionValue;
        var tds = document.getElementsByTagName("td");
        for (var x = 0; x < tds.length; x++)
          if (tds[x].innerHTML == "Нет данных" || tds[x].innerHTML == "Мәлімет жоқ")
            tds[x].innerHTML = noDatValue
        clearInterval(x);
      }
    }, 10);

    this.settings = {
      // add: {
      //   addButtonContent: '<i class="nb-plus"></i>',
      //   createButtonContent: '<i class="nb-checkmark"></i>',
      //   cancelButtonContent: '<i class="nb-close"></i>',
      //   confirmCreate: true,
      // },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        onDeleteConfirm: true,
        confirmDelete: true,
      },
      pager: {
        display: true,
        perPage: 15
      },
      noDataMessage: noDatValue,
      actions: {
        columnTitle: actionValue,
        add: false,
      },
      columns: {

        ndex: {
          title: "№",
          type: "text",
          width: '3%',
          editable: false, addable: false,
          valuePrepareFunction(value, row, cell) { return (cell.row.index + 1); }
        },
        IDN: {
          title: this.translate.instant('IIN'),
          editable: false,
          width: '14%',
          type: 'html',
          editor: {
            type: 'custom',
            component: CustomEditorComponent2,
          },
        },
        FM: {
          title: this.translate.instant('LASTNAME'),
          editable: false,
          type: 'html',
          width: '10%',
          editor: {
            type: 'custom',
            component: CustomEditorComponent3,
          },
        },
        NM: {
          title: this.translate.instant('FIRSTNAME'),
          editable: false,
          type: 'html',
          editor: {
            type: 'custom',
            component: CustomEditorComponent4,
          },
        },
        FT: {
          title: this.translate.instant('MIDDLENAME'),
          editable: false,
          type: 'html',
          editor: {
            type: 'custom',
            component: CustomEditorComponent5,
          },
        },
        BIRTHDATE: {
          title: this.translate.instant('BIRTHDAY'),
          editable: false,
          width: '12%',
          type: 'html',
          editor: {
            type: 'custom',
            editable: false,
            component: CustomEditorComponent15,
          },

        },
        PERIOD: {
          title: this.translate.instant('PERIODPAY'),
          editable: false,
          type: 'html',
          editor: {
            type: 'custom',
            editable: false,
            component: CustomEditorComponent7,
          },
        },

        SUM: {
          title: this.translate.instant('SUM'),
          editor: {
            type: 'custom',
            component: CustomEditorComponent8,
          }
        }
      },

    };

    // this.personsN = [
    //   {
    //     "ndex": "",
    //     "IDN": "991113300577",
    //     "FM": "",
    //     "NM": "",
    //     "FT": "",
    //     "BIRTHDATE": "",
    //     "PERIOD": "",
    //     "SUM": "5000"
    //   },
    //   {
    //     "ndex": "",
    //     "IDN": "991113300577",
    //     "FM": "",
    //     "NM": "",
    //     "FT": "",
    //     "BIRTHDATE": "",
    //     "PERIOD": "",
    //     "SUM": "5000"
    //   }
    // ];

  }

  open(dialog: TemplateRef<any>) {
    this.dialogService.open(dialog, { context: 'this is some additional data passed to dialog' });
  }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public isNumberValid(): boolean {

    if ((/^[0-9]+$/.test(this.numberPayment)) || this.numberPayment.length > 0) {
      return true

    }
    else return false;
  }


  paymentClick() {
    sessionStorage.setItem('NUMBER', this.numberPayment);
    sessionStorage.setItem('CHIEF', this.jurPerson.CHIEF);
  }
  addDatePayment(event: MatDatepickerInputEvent<Date>): any {
    this.today = new FormControl(new Date(event.value));
    this.datePayment = formatDate(event.value, 'dd.MM.yyyy', 'en-US');

  }
  addDatePayment1(event: MatDatepickerInputEvent<Date>): any {
    this.datePayment1 = formatDate(event.value, 'dd.MM.yyyy', 'en-US');

  }
  ngOnInit() {
    
    this.translateLang();
    this.KBE = sessionStorage.getItem("KBE");
    this.BIC = sessionStorage.getItem("bicBank");
    this.BIN = sessionStorage.getItem("binBank");

    this.dataA = sessionStorage.getItem("PDF");
    this.indexEconome = 0;





    this.reciverData = <ReciverList>{};
    // this.resiverName=this.reciver[this.indexEconome].name;
    this.datePayment = formatDate(this.today.value, 'dd.MM.yyyy', 'en-US');

    this.datePayment1 = formatDate(this.today1.value, 'dd.MM.yyyy', 'en-US');
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ''
    });
    //this.data1=JSON.parse(sessionStorage.getItem("data1"));  
    // this.personsN = JSON.parse(sessionStorage.getItem('persons'));

    try {
      if (!sessionStorage.getItem('jurPerson')) {
        Swal.fire({
          text: this.translate.instant('ALERTNOSERVICE'),
          type: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: "#008e54"
        })
        this.router.navigate(['/auth/login']);
      }
      else {
        console.log('sessionJur= ' + sessionStorage.getItem('jurPerson'));
        let that = this;
        this.rest.getJurPerson(sessionStorage.getItem('jurPerson')).subscribe((data: Result) => {
          if (data.code == '0') {
            let base64 = data.message.toString();
            let jsonString = Base64.decode(base64);
            that.data1 = JSON.parse(jsonString);
            let pers = JSON.parse(jsonString);
            that.token = JSON.parse(sessionStorage.getItem('jurPerson')).token;
            this.IBAN = pers.BANK_IBAN;

            sessionStorage.setItem("ibanBank", this.IBAN);
            that.personsN = pers.persons;
            that.address = pers.ADDRESS;
            that.nameCompany = pers.NAME_JUR;
            that.idn = pers.IDN;
            console.log(pers);
            console.log('idn ' + that.idn)
            that.chief = pers.CHIEF;
            that.nameBank = pers.BANK.replace(/(&quot\;)/g,"\"");
            that.bicBank - pers.BANK_BIK;
            let self = that;
            this.changeDetectorRefs.detectChanges();
            that.rest.getBanksList().subscribe((data: string) => {
              let b: bank[] = <bank[]>JSON.parse(JSON.stringify(data));
              self.banks = b.filter((d) => {
                return (d.metadata.iban !== "" && d.metadata.iban !== null);
              });

              for (let i = 0; i < self.banks.length; i++) {
                if (self.banks[i].metadata.bic == pers.BANK_BIK) {
                  self.IBAN = this.banks[i].metadata.iban;
                  self.nameBank = this.banks[i].metadata.nameRu;

                }
                this.changeDetectorRefs.detectChanges();
              }
              console.log(self.banks);
            });

            //Перовод языка

            this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
              this.translate.use(event.lang);
              this.translateLang();
            });
            //Получение сектора экономики
            this.rest.getEconomySector().subscribe((data: any) => {
              //this.title = JSON.stringify(data); 
              if (data.code == "-1") {
                Swal.fire({
                  text: data.message,
                  type: 'error',
                  confirmButtonText: 'OK',
                  confirmButtonColor: "#008e54"
                })
              }
              else {


                this.sector = [];
                this.sector = JSON.parse(JSON.parse(JSON.stringify(data)).message);

                // for (let i=0; i<this.sector.length; i++){

                // }
                // this.numberBudget = this.sector[0].code.toString();
                console.log(this.sector[0].code);
              }
            },
              error => {
                this.title = JSON.stringify(error);
              });
            //Получение данные получателя 
            this.rest.getRecieverData().subscribe((data: any) => {
              if (data.code == "-1") {
                Swal.fire({
                  text: data.message,
                  type: 'error',
                  confirmButtonText: 'OK',
                  confirmButtonColor: "#008e54"
                })
              }
              else {

                this.reciver = [];
                this.reciver = JSON.parse(JSON.parse(JSON.stringify(data)).message);
                this.reciverData = this.reciver[this.indexEconome];
                console.log(this.reciver);
              }
            },
              error => {
                this.title = JSON.stringify(error);
              });
            //Получение Код назначение платежа  
            this.rest.getCodePayment().subscribe((data: any) => {
              if (data.code == "-1") {
                Swal.fire({
                  text: data.message,
                  type: 'error',
                  confirmButtonText: 'OK',
                  confirmButtonColor: "#008e54"
                })
              }
              else {

                this.payment = [];
                this.payment = JSON.parse(JSON.parse(JSON.stringify(data)).message);
              }
            },
              error => {
                this.title = JSON.stringify(error);
              });

            //Установка Редиденситва 

            this.translate.get(['RESIDENT', 'NORESIDENT']).subscribe(translations => {
              this.residentType = translations.RESIDENT;
              console.log(this.residentType);
            });

          }
          if (data.code == '-4') {
            Swal.fire({
              text: data.message,
              type: 'warning',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
            sessionStorage.setItem('jurPerson', '');
            sessionStorage.setItem('jurName', '');
            this.router.navigate(['/auth']);
          }
          if (data.code == '-1') {
            sessionStorage.setItem('errorMessage', data.message);
            sessionStorage.setItem('jurPerson', '');
            sessionStorage.setItem('jurName', '');
            console.error('error - 2 - ' + data.message);
            Swal.fire({
              text: this.translate.instant('ALERTNOSERVICE'),
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
          }
        })
      }
    }
    catch (e) {
      console.error("error in get Economy" + e.message);
      Swal.fire({
        text: e.message,
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
      this.router.navigate(['/jur']);
    }


    this.firstForm = this.fb.group({
      firstCtrl: ['', Validators.required],
    });

    this.secondForm = this.fb.group({
      secondCtrl: ['', Validators.required],
    });

    this.thirdForm = this.fb.group({
      thirdCtrl: ['', Validators.required],
    });

    //this.isComplateForm1();

  }
  //pt:PaymentsType;
  //details:DETAIL[];
  //detail:DETAIL;

  ngAfterViewInit() {
    this.clearAll();

    let pattern = `<a id="search__button" class="ng2-smart-action ng2-smart-action-add-add ng-star-inserted" href="#" style="margin-bottom: 0px; font-size: 15px !important; font-weight: 500;"></a>`;

    let el = document.querySelector('.ng2-smart-actions-title-add');


    var newItem = document.createElement("DIV");
    newItem.innerHTML = pattern;

    el.insertBefore(newItem, el.childNodes[0]);

    let searchButton = document.getElementById("search__button");

    searchButton.innerHTML = sessionStorage.getItem('lang') == "0" ? "Поиск" : "Іздеу";

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.translate.use(event.lang);
      this.translateLang(event.lang, true);
      searchButton.innerHTML = event.lang == "ru" ? "Поиск" : "Іздеу";
    });


    searchButton.addEventListener('click', (ev) => {
      ev.preventDefault();
    });
  }

  submitPP() {

    let pt = new PaymentsTypeClass();
    pt.DETAIL = [];
    try {

      pt.ASSIGN = this.assign;
      pt.TXN_ID = this.data1.ID_JUR;
      pt.BIN = this.data1.IDN;
      pt.CONTRACTTYPE = this.numbers;
      pt.CUSTOMER_KEY = '';
      pt.LANG = '0';
      pt.SIGNATURE = '';
      pt.TOTALSUM = this.totalsum;
      pt.DATEPAY = this.datePayment;
      pt.DATEVAL = this.datePayment1;
      pt.BANK = this.nameBank;
      pt.MFO = this.bicBank;
      pt.IBAN = this.IBAN;
      pt.NUM = this.numberPayment;
      pt.token = this.token;

      for (let i = 0; i < this.personsN.length; i++) {
        if(this.personsN[i].SUM != 0) {
          let detail = new dtClass(this.personsN[i].IDN, this.personsN[i].NM, this.personsN[i].FM, this.personsN[i].FT, "", this.personsN[i].SUM, this.personsN[i].PERIOD)
          pt.DETAIL.push(detail);
        }
      }
      let jsonString1 = JSON.stringify(pt);

      //let base64String1 = Base64.encode(jsonString1);

      this.rest.savePP(jsonString1).subscribe((data: any) => {
        if (data.code == "-1") {
          Swal.fire({
            text: data.message,
            type: 'error',
            confirmButtonText: 'OK'
          })

        }
        if (data.code == "0") {
          Swal.fire({
            text: this.translate.instant('ALERTSAVEPP'),
            type: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
          })

        }

      },
        error => {
          console.log(error);
        });
      console.log(jsonString1);

      // sessionStorage.setItem("Payment",jsonString1);

    }
    catch (e) {
      console.log('Error was fixed')
    }


  }
  onFirstSubmit() {
    console.log('second tab');
    // this.firstForm.markAsDirty();
  }

  onSecondSubmit() {
    this.secondForm.markAsDirty();
  }

  onThirdSubmit() {
    this.thirdForm.markAsDirty();
  }
  // Изменение при выборе КНП

  secletedCodePayment(selectedValue1: any) {
    console.log(selectedValue1.match(/(\d+)/).toString().slice(0, 3));
    this.numbers = selectedValue1.match(/(\d+)/).toString().slice(0, 3);
    if (this.numbers == '010' || this.numbers == '015' || this.numbers == '019' || this.numbers == '009') {
      if(this.numbers == '015' || this.numbers == '009') {
        this.numberBudget = '903101';
      } else {
        this.numberBudget = '901101';
      }
      this.indexEconome = 0;
      this.reciverData = this.reciver[this.indexEconome];
    }
    if (this.numbers == '013') {
      this.numberBudget = ' ';
      this.indexEconome = 1;
      this.reciverData = this.reciver[this.indexEconome];
    }

  }
  secletedEconomy(selectedValue: any) {

    // this.numberBudget = selectedValue.match(/\d+/g).map(Number).toString();
    // console.log(this.numberBudget);

    //

  }
  isComplateForm() {
    if (this.residentType && this.numbers && this.isComplate == false && this.numberBudget) {
      return false
    }
    else return true
  }
  public isSetResident() {
    if (this.residentType) {
      return true;
    }
    else return false
  }
  public isSetPayment() {
    if (this.numbers) {
      return true;
    }
    else return false

  }
  public isSetEconomy() {
    if (this.numberBudget) {
      return false;
    }
    else return true;

  }
  secletedResident(selectedValue: any) {

    this.residentType = selectedValue;
    console.log(this.numberBudget + '****////' + this.numbers);

  }

  selectedPersons(selectedValue1) {
    console.log(selectedValue1);
  }

  isComplForm: boolean = true;

  checkInputChange(evt: any) {
    this.isComplateForm1();
  }
  // Проверка при Формирование реестра
  isComplateForm1(val = true) {
    if (!val) {
      this.isComplForm = false;
      return;
    }
    let np = this.numberPayment;
    let iban = this.IBAN;
    let pp = this.personsN;

    // if (this.numberPayment && this.IBAN && this.personsN.length != 0) {
    if (this.personsN.length > 0) {

      for (let i = 0; i < this.personsN.length; i++) {
        if (parseInt(this.personsN[i].SUM) != 0) {
          this.isComplForm = false;
          return;
        }
      }
       Swal.fire({
            text: "Сумма должна превышать нуля",
            type: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
          })
      this.isComplForm = true;

    }
    else { this.isComplForm = true; }

    // this.ncalayer.getChangeSum().subscribe((sum: string) => {
    //   if(sum!=""&& this.numberPayment&&this.IBAN){
    //     return false;
    //   }
    //   else {
    //     if(sum=='0'){
    //         Swal.fire({
    //         text: `Сумма по ИИН ${this.personsN[i].IDN} не должна быть 0`,
    //         type: 'error',
    //         confirmButtonText: 'OK',
    //         confirmButtonColor: "#008e54"
    //       })
    //     }
    //     return true;
    //   }
    // });
  }


  //Формирование реестра
  formReestr() {

    if (this.checkInputNumber() !== "success") {
      Toast.fire({
        type: 'warning',
        title: this.translate.instant('ALERTREESTRNUMBER')
      });
      return;
    }

    // if (this.isComplateForm1) {
    //   Toast.fire({
    //     type: 'warning',
    //     title: `${this.translate.instant('ALERTSUM')} ${this.translate.instant('ALERTSUM0')}`
    //   });
    //   return;
    // }


    this.totalsum = 0;
    // sessionStorage.setItem('PERSONS',this.personsN);
    console.log(this.personsN);
    for (let i = 0; i < this.personsN.length; i++) {
        this.totalsum = this.totalsum + parseFloat(this.personsN[i].SUM);
    }

    if(this.totalsum == 0) {
        Toast.fire({
        type: 'warning',
        title: `${this.translate.instant('ALERTFILLSUM')}`
      });
      return;
    }


    this.totalsum = this.totalsum.toString();
    sessionStorage.setItem('NAMECOM', this.data1.NAME_JUR);
    Toast.fire({
      type: 'success',
      title: this.translate.instant('ALERTREESTR')
    });


    this.move(1);
  }

  move(index: number) {
    this.stepper.selectedIndex = index;
  }

  // sessionStorage.setItem('TOTALSUM',this.totalsum);


  clearAll() {

    console.log('clearALL');
    try {

      this.source = new LocalDataSource();
      this.personsN = []
      // this.onCreateConfirm(event);  

      //this.source.load(this.personsN);
      // this.source.empty();
      // this.source.reset();
      // this.source.refresh();      
      this.source.remove(this.source.getElements())
      this.source.setFilter([], true, false);
      this.source.refresh();
      this.source.load(this.personsN);
      sessionStorage.setItem("persons", JSON.stringify(this.personsN));
      console.log(JSON.stringify(this.personsN))
    }
    catch (e) {
      console.log(e);

    }
  }

  onDeleteConfirm(event) {

    this.personsN.splice(this.personsN.indexOf(event.data), 1);
    event.confirm.resolve();
    this.isComplateForm1(false);

  }

  onSaveConfirm(event) {
    this.isComplateForm1(false);
    try {
      let summa
      this.ncalayer.getChangeSum().subscribe((sum: string) => {
        summa = sum;
        console.log(sum)
      });
      console.log(event)
      if (event.newData.SUM == '0' || summa == '0' || summa == 0) {
        Swal.fire({
          text: `${this.translate.instant('ALERTSUM')} ${event.newData.IDN} ${this.translate.instant('ALERTSUM0')}`,
          type: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: "#008e54"
        })
        event.confirm.reject();
      }
      if (event.newData.SUM == '') {
        Swal.fire({
          text: `${this.translate.instant('ALERTSUM')} ${event.newData.IDN} ${this.translate.instant('ALERTSUM0')}`,
          type: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: "#008e54"
        })
        event.confirm.reject();
      }
      if (event.newData.PERIOD == '') {
        Swal.fire({
          text: `${this.translate.instant('ALERTFILLPERIOD')}`,
          type: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: "#008e54"
        })
        event.confirm.reject();
      }
      if (event.newData.SUM != '0' && event.newData.SUM != '' && event.newData.SUM != '00' && event.newData.SUM != '000' && event.newData.SUM != 0) {

        event.confirm.resolve(event.newData);
        this.isComplateForm1(false);
      }
      else {
        event.confirm.reject();
      }
      // if (sum=='0'){  
      //   Swal.fire({
      //     text: `Сумма по ИНН ${event.newData.IDN} равно 0`,
      //     type: 'error',
      //     confirmButtonText: 'OK',
      //     confirmButtonColor: "#008e54"
      //   })
      //   event.confirm.reject();
      // } 
      // if (sum ==''){  
      //   Swal.fire({
      //     text: `Сумма по ИНН ${event.newData.IDN} пустая`,
      //     type: 'error',
      //     confirmButtonText: 'OK',
      //     confirmButtonColor: "#008e54"
      //   })
      //   event.confirm.reject();
      // } 
      // if (sum !='0'&&sum !=''){  

      //   event.confirm.resolve(event.newData);
      //   }
      //   else {
      //     event.confirm.reject();
      //   }


    }
    catch (e) {
      Swal.fire({
        text: this.translate.instant('ALERTNOSERVICE'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
  }
  checkIin(Name: any): boolean {

    if (Name.length != 12) return false;
    if (!(/[0-9]{12}/.test(Name))) return false;
    var b1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    var b2 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
    var a = [];
    var controll = 0;
    for (var i = 0; i < 12; i++) {
      a[i] = parseInt(Name.substring(i, i + 1));
      if (i < 11) controll += a[i] * b1[i];
    }
    controll = controll % 11;
    if (controll == 10) {
      controll = 0;
      for (var i = 0; i < 11; i++)
        controll += a[i] * b2[i];
      controll = controll % 11;
    }
    if (controll != a[11]) { return false; }

    return true;
  }


  onCreateConfirm(event) {
    //  console.log(' onCreateConfirm ' + JSON.stringify(this.personsN));
    console.log('checkIIN' + this.checkIin(event.newData.IDN));
    if (event.newData.IDN.length == 0) {
      Swal.fire({
        text: this.translate.instant('ALERTIINEMP'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
    if (this.checkIin(event.newData.IDN) == false) {
      Swal.fire({
        text: this.translate.instant('ALERTERR'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
    if (event.newData.SUM.length == 0) {
      Swal.fire({
        text: this.translate.instant('ALERTFILLSUM'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
    if (event.newData.IDN.length != 0 && this.checkIin(event.newData.IDN) == true && event.newData.SUM.length != 0) {
      // this.personsN.push(event.newData);
      // event.newData['name'] += ' + added in code';
      event.confirm.resolve(event.newData);
      this.isComplateForm1(false);
    } else {
      event.confirm.reject();
    }

    // this.personsN.push(event.newData);
    // // event.newData['name'] += ' + added in code';
    // event.confirm.resolve(event.newData);

  }
  openIframe(event: any) {
    // if (

    // ){}

    // else 

    this.isComplate2 = false;




    var bodyData = [];
    var bodyData1 = [];
    var sourceData = this.personsN;
    var dataRow1 = [];
    let n = 1;
    let m = 1;
    this.blnkStatus = false;
    sourceData.forEach(function (sourceRow) {
      var dataRow = [];
      if(sourceRow.SUM != 0) {
        number: dataRow.push(n);
        ID: dataRow.push(sourceRow.IDN);
        Name: dataRow.push(sourceRow.FM);
        LastName: dataRow.push(sourceRow.NM);
        Surname: dataRow.push(sourceRow.FT);
        BB: dataRow.push(sourceRow.BIRTHDATE);
        Period: dataRow.push(sourceRow.PERIOD);
        SUM: dataRow.push(sourceRow.SUM);
        
        bodyData.push(dataRow);
        n++;
      }

    });
    ID: dataRow1.push('№');
    Name: dataRow1.push(this.translate.instant('IIN'));
    Surname: dataRow1.push(this.translate.instant('LASTNAME'));
    LastName: dataRow1.push(this.translate.instant('FIRSTNAME'));
    LastName: dataRow1.push(this.translate.instant('MIDDLENAME'));
    LastName: dataRow1.push(this.translate.instant('BIRTHDAY'));
    LastName: dataRow1.push(this.translate.instant('PERIODPAY'));
    LastName: dataRow1.push(this.translate.instant('SUM'));
    //dataRow.unshift('№','ИИН','Фамилия','Имя','Отчество','Дата рождения','Период Платаежа','Сумма');
    bodyData.unshift(dataRow1);
    console.log('this is code' + (bodyData));
    //this.showToast1('bottom-start','default','Поручение сформировано');
    Toast.fire({
      type: 'success',
      title: this.translate.instant('ALERTPPFORMED')
    });
    var dd = {
      // pageSize: 'A4',
      pageOrientation: 'portrait',
      content: [
        { text: this.translate.instant('ALERTPPNUMBER') + ' ' + this.numberPayment, style: 'header', alignment: 'center' },
        { text: this.translate.instant('DATE') + ': ' + this.datePayment, fontSize: 10, margin: [0, 10, 0, 2] },
        {
          style: {
            header: {
              fontSize: 25,
              bold: true,
              alignment: 'center',
            },
            headerRow: {
              bold: true,
              alignment: 'center',
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5]
            },
            tableExample: {
              margin: [0, 5, 0, 15],
              fontSize: 10,
              color: 'black'
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            },
            textTable: {
              fontSize: 10,
              color: 'black'
            }
          }
          ,
          table: {
            widths: [220, 150, 30, 100],

            body: [

      /*1 row*/[

                [{ colSpan: 1, text: [{ text: this.translate.instant('SendMoney') + ': ' }, { text: this.data1.NAME_JUR, bold: true, }] }, { colSpan: 1, text: [{ text: '\n: ' + this.translate.instant('BIN') }, { text: this.data1.IDN, bold: true }] }],
                [{ text: this.translate.instant('IIK'), alignment: 'center', }, { text: '\n' + this.IBAN, alignment: 'center', bold: true }],
                [{ text: this.translate.instant('CODE'), alignment: 'center' }, { text: '\n' + this.KBE, alignment: 'center', bold: true }],
                { rowSpan: 5, text: [{ text: this.translate.instant('SUM') + '\n\n\n\n\n\n\n\n', alignment: 'center' }, { text: this.totalsum, alignment: 'center', bold: true }] }
              ],

      /*2 row*/[
                { colSpan: 1, text: [{ text: this.translate.instant('BANKSENDER') + ': ' }, { text: this.nameBank, bold: true }] },
                { colSpan: 2, text: [{ text: this.translate.instant('BIK') + '\n\n', alignment: 'center' }, { text: this.data1.BANK_BIK, alignment: 'center', bold: true }] },
                '',
                ''
              ],

      /*3 row*/[
                [{ colspan: 1, text: [{ text: this.translate.instant('BENIFICIAR') + ': ' }, { text: this.reciver[this.indexEconome].name, bold: true }] }, { colSpan: 1, text: [{ text: '\nБИН: ' }, { text: this.reciver[this.indexEconome].bin, bold: true }] }],
                [{ text: this.translate.instant('IIK') + '\n\n\n', alignment: 'center' }, { text: this.reciver[this.indexEconome].account, bold: true, alignment: 'center' }],
                [{ text: this.translate.instant('KBE') + '\n\n\n', alignment: 'center' }, { text: this.reciver[this.indexEconome].kBe, alignment: 'center' }],
                ''
              ],

      /*4 row*/[
                { colSpan: 1, text: [{ text: this.translate.instant('BANKCHNAGED') + ': ' }, { text: this.reciver[this.indexEconome].bank, bold: true }] },
                { colSpan: 2, text: [{ text: this.translate.instant('BIK'), alignment: 'center' }, { text: '\n\n' + this.reciver[this.indexEconome].bik, bold: true, alignment: 'center' }] },
                '',
                ''
              ],

      /*5 row*/[
                { colSpan: 3, text: [{ text: this.translate.instant('SumCuirsive') + ': ' }, { text: this.number_to_string(parseFloat(this.totalsum)), bold: true }] },
                '',
                '',
                ''
              ],

      /*6 row*/[
                { rowSpan: 2, text: '' },
                { colSpan: 2, text: this.translate.instant('OPERATION'), alignment: 'center' },
                '',
                { text: this.numbers, alignment: 'center', bold: true }
              ],

      /*7 row*/[
                '',
                { colSpan: 2, text: this.translate.instant('KBKFull'), alignment: 'center', margin: [0, 5] },
                '',
                { text: this.numberBudget, alignment: 'center', bold: true, margin: [0, 5] }
              ],

    /*8 row*/[
                [{ text: this.translate.instant('CODEASSING') + ':' }, { text: this.assign, bold: true }],
                { colSpan: 2, text: this.translate.instant('DateValuation'), alignment: 'center', margin: [0, 25] },
                '',
                { text: this.datePayment1, alignment: 'center', bold: true, margin: [0, 25] }
              ]
            ]
          }

        },
        { text: this.translate.instant('CHIEF'), fontSize: 10, margin: [0, 40, 0, 2] },
        { text: this.translate.instant('BankReciverSend'), fontSize: 10, margin: [320, -14, 0, 2] },
        { text: this.translate.instant('PlaceOfPrinting'), fontSize: 10, margin: [0, 10, 0, 2] },


        {
          pageBreak: 'before',
          pageOrientation: 'landscape',
          text: this.translate.instant('LISTOFPANCIOUS'), style: 'header', alignment: 'center', margin: [0, 10]
        },
        { text: this.translate.instant('TOPAYMENT') + ' ' + this.numberPayment + ' ' + this.translate.instant('DATEFROM') + ' ' + this.datePayment, fontSize: 10, margin: [0, 10, 0, 2] },
        { text: '' + this.data1.NAME_JUR, fontSize: 10, margin: [0, 4, 0, 2] },
        { text: this.translate.instant('BIN') + ' ' + this.data1.IDN, fontSize: 10, margin: [0, 4, 0, 2] },
        { text: this.translate.instant('CODE') + ' ' + this.KBE, fontSize: 10, margin: [0, 4, 0, 2] },
        { text: this.translate.instant('IIK') + ' ' + this.IBAN, fontSize: 10, margin: [0, 4, 0, 2] },

        {
          style: 'tableExample', margin: [0, 8], fontSize: 10,
          table: {
            headerRows: 1, style: 'headerRow',
            widths: [15, 70, '*', '*', '*', 60, 60, '*'],



            // [
            // {text:  '№, п/п', fontSize: 10, margin: [0, 4, 0, 2] },
            // {text:  'ИИН', fontSize: 10,  alignment: 'center', margin: [0, 8] },
            // {text:  'Фамилия', fontSize: 10, alignment: 'center', margin: [0, 8] },
            // {text:  'Имя', fontSize: 10, alignment: 'center', margin: [0, 8] },
            // {text:  'Отчество', fontSize: 10, alignment: 'center', margin: [0, 8]},
            // {text:  'Дата рождения', fontSize: 10, alignment: 'center', margin: [0, 8]},
            // {text:  'Период платежа', fontSize: 10, alignment: 'center', margin: [0, 8]},
            // {text:  'Сумма', fontSize: 10, alignment: 'center', margin: [0, 8]}

            // ],  

            body: bodyData,

          }
        },
      ]

    };


    // pdfMake.createPdf(dd).open();
    const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getBase64((data) => {
      console.log(typeof (data));
      console.log(this.dataA = "data:application/pdf;base64," + data);
      //  let myDiv = document.getElementById('my-div');
      //  myDiv.setAttribute("src", this.dataA); // adds a src attribute (with the value myPath) to myImg
      //  document.getElementById("myFrame").src = this.dataA;
      //  document.getElementById('myFrame').setAttribute("src", this.dataA);
      //  $("#myFrame").attr("src", "www.google.com");
      this.dataA = this.sanitizer.bypassSecurityTrustResourceUrl(this.dataA)
      sessionStorage.setItem('PDF', this.dataA);

      // let iframe = this.hostElement.nativeElement.querySelector('iframe');
      // iframe.src = this.dataA;

    });
  }


  //формирование число с прописью

  //  public inWords (num:any) {
  //   let a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
  //   let b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];
  //    let n;
  //     if ((num = num.toString()).length > 9) return 'overflow';
  //     n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  //     if (!n) return; var str = '';
  //     str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
  //     str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
  //     str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
  //     str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'сто ' : '';
  //     str += (n[5] != 0) ? ((str != '') ? ' ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'тенге ' : '';
  //     console.log('inwords'+str); 
  //     return str;
  // }

  /**
   * Возвращает сумму прописью
   */
  number_to_string(num: any) {
    var def_translite = {
      null: this.translate.currentLang == 'ru' ? 'ноль' : 'нөл',
      a1: this.translate.currentLang == 'ru' ? ['один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'] : ['бір', 'екі', 'үш', 'төрт', 'бес', 'алты', 'жеті', 'сегіз', 'тоғыз'],
      a2: this.translate.currentLang == 'ru' ? ['одна', 'две', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'] : ['бір', 'екі', 'үш', 'төрт', 'бес', 'алты', 'жеті', 'сегіз', 'тоғыз'],
      a10: this.translate.currentLang == 'ru' ? ['десять', 'одиннадцать', 'двенадцать', 'тринадцать', 'четырнадцать', 'пятнадцать', 'шестнадцать', 'семнадцать', 'восемнадцать', 'девятнадцать'] : ['он', 'он бір', 'он екі', 'он үш', 'он төрт', 'он бес', 'он алты', 'он жеті', 'он сегіз', 'он тоғыз'],
      a20: this.translate.currentLang == 'ru' ? ['двадцать', 'тридцать', 'сорок', 'пятьдесят', 'шестьдесят', 'семьдесят', 'восемьдесят', 'девяносто'] : ['жиырма', 'отыз', 'қырық', 'елу', 'алпыс', 'жетпіс', 'сексен', 'тоқсан'],
      a100: this.translate.currentLang == 'ru' ? ['сто', 'двести', 'триста', 'четыреста', 'пятьсот', 'шестьсот', 'семьсот', 'восемьсот', 'девятьсот'] : ['жүз', 'екі жүз', 'үш жүз', 'төрт жүз', 'бес жүз', 'алты жүз', 'жеті жүз', 'сегіз жүз', 'тоғыз жүз'],
      uc: ['тиын', 'тиын', 'тиын'],
      ur: ['тенге', 'тенге', 'тенге'],
      u3: this.translate.currentLang == 'ru' ? ['тысяча', 'тысячи', 'тысяч'] : ['мың', 'мың', 'мың'],
      u2: this.translate.currentLang == 'ru' ? ['миллион', 'миллиона', 'миллионов'] : ['миллион', 'миллион', 'миллион'],
      u1: this.translate.currentLang == 'ru' ? ['миллиард', 'миллиарда', 'миллиардов'] : ['миллиард', 'миллиард', 'миллиард'],
    }
    var i1, i2, i3, kop, out, rub, v, zeros, _ref, _ref1, _ref2, ax;

    _ref = parseFloat(num).toFixed(2).split('.'), rub = _ref[0], kop = _ref[1];
    var leading_zeros = 12 - rub.length;
    if (leading_zeros < 0) {
      return false;
    }

    zeros = [];
    while (leading_zeros--) {
      zeros.push('0');
    }
    rub = zeros.join('') + rub;
    out = [];
    if (rub > 0) {
      // Разбиваем число по три символа
      _ref1 = this.str_split(rub, 3);
      for (var i = -1; i < _ref1.length; i++) {
        v = _ref1[i];
        if (!(v > 0)) continue;
        _ref2 = this.str_split(v, 1), i1 = parseInt(_ref2[0]), i2 = parseInt(_ref2[1]), i3 = parseInt(_ref2[2]);
        out.push(def_translite.a100[i1 - 1]); // 1xx-9xx
        ax = (i + 1 == 3) ? 'a2' : 'a1';
        if (i2 > 1) {
          out.push(def_translite.a20[i2 - 2] + (i3 > 0 ? ' ' + def_translite[ax][i3 - 1] : '')); // 20-99
        } else {
          out.push(i2 > 0 ? def_translite.a10[i3] : def_translite[ax][i3 - 1]); // 10-19 | 1-9
        }

        if (_ref1.length > i + 1) {
          var name = def_translite['u' + (i + 1)];
          out.push(this.morph(v, name));
        }
      }
    } else {
      out.push(def_translite.null);
    }
    // Дописываем название "тенге"
    out.push(this.morph(rub, def_translite.ur));
    // Дописываем название "тиын"
    out.push(kop + ' ' + this.morph(kop, def_translite.uc));

    // Объединяем маcсив в строку, удаляем лишние пробелы и возвращаем результат
    return out.join(' ').replace(RegExp(' {2,}', 'g'), ' ').trimLeft();
  };

  /**
   * Преобразует строку в массив
   */

  str_split(string, length) {
    var chunks, len, pos;

    string = (string == null) ? "" : string;
    length = (length == null) ? 1 : length;

    chunks = [];
    pos = 0;
    var len = string.length;
    while (pos < len) {
      chunks.push(string.slice(pos, pos += length));
    }

    return chunks;
  };
  /**
   * Склоняем словоформу
   */
  morph(number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];
    return titles[(number > 4 && number < 20) ? 2 : cases[Math.min(number, 5)]];
  };


};
